import React, { FC } from "react";
import { StyledContainer } from "src/components/common";

const Albums: FC = () => {
  return <StyledContainer>Albums</StyledContainer>;
};

export default Albums;
